import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from './Link';

const RainbowHeader = styled.div`
  border: 1px solid #ffc783;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 4px;
  &:before {
    content: '';
    display: block;
    height: 3rem;
    margin-top: -3rem;
    visibility: hidden;
  }
`;

const HelpCallout = () => (
  <RainbowHeader>
    <FormattedMessage
      defaultMessage="If you have questions, Discord community is a good place to get help!
          You can find support on {discord}"
      values={{
        discord: (
          <Link primary inline to="https://discord.gg/fusionistio">
            Discord
          </Link>
        ),
        // reddit: (
        //   <Link primary inline to="https://reddit.com/r/ethstaker">
        //     Reddit
        //   </Link>
        // ),
      }}
      description="{variables} social media platform links to Discord (do not translate names)"
    />
  </RainbowHeader>
);

export default HelpCallout;
